import { prop } from 'ramda';
import { writable, derived } from 'svelte/store';
export const trial = writable(null);
export const golfTrial = derived(trial, ($trial) => $trial);
export const comparisonTrial = writable(null);
export const comparisonTrialData = derived(comparisonTrial, prop('data'));
